import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

interface AdvisorDTO {
  AdviserEmail: string;
  AdviserFirstName: string;
  AdviserId: number;
  AdviserLastName: string;
  AdviserName: string;
  IsManager: boolean;
}

const fetchSameOrgAdvisors = async (): Promise<AdvisorDTO[]> => {
  const { Advisers } = await authFetch(
    urlWithParams('/Adviser/Adviser/GetAdvisersInSameOrganization', { accessToCampaigns: true }),
  );

  return Advisers;
};

export const useSameOrgAdvisorsQuery = () => {
  return useQuery(
    queryKeys.sameOrgAdvisors(),

    () => fetchSameOrgAdvisors(),

    {
      cacheTime: 0,
    },
  );
};
